<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Planogram Feedback</h4>
  <button
    type="button"
    class="btn btn-link p-0 border-0"
    aria-label="Close"
    (click)="close()"
  >
    <i class="bi bi-x-lg"></i>
  </button>
</div>

<div class="modal-body p-3">
  <!-- Feedback list with conditional display -->
  <div class="feedback-list" *ngIf="!loading && feedbackList.length > 0; else noFeedbackTpl">
    <div ngbAccordion>
      <!-- My Feedback section -->
      <div ngbAccordionItem *ngIf="groupedFeedback['My Feedback']">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>My Feedback</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <ng-container
                *ngTemplateOutlet="feedbackTemplate; context: { list: groupedFeedback['My Feedback'], level: 0 }"
              ></ng-container>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Other Users -->
      <div ngbAccordionItem *ngFor="let email of otherUsers">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>{{ email }}</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <ng-container
                *ngTemplateOutlet="feedbackTemplate; context: { list: groupedFeedback[email], level: 0 }"
              ></ng-container>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- No feedback message -->
  <ng-template #noFeedbackTpl>
    <div class="text-center text-muted py-4">
      No feedback as been added just yet.
    </div>
  </ng-template>

  <!-- Loading state -->
  <ng-template #loadingTpl>
    <div class="text-center py-4">Loading feedback...</div>
  </ng-template>
</div>

<!-- Recursive feedback template -->
<ng-template #feedbackTemplate let-list="list" let-level="level">
  <div *ngFor="let fb of list" class="feedback-item" [style.marginLeft.px]="level * 20">
    <div class="card mb-2">
      <div class="card-header bg-primary d-flex align-items-center justify-content-between">
        <p class="m-0 text-light">{{ fb.email }}</p>
        <div class="d-flex align-items-center gap-3">
          <small class="text-light">{{ fb.dateCreated | date: 'short' }}</small>

          <!-- ✅ Display badges for completed or approved feedback -->
          <ng-container *ngIf="fb.tags?.includes('feedback-completed')">
            <span class="badge bg-info text-dark">Feedback Completed</span>
          </ng-container>
          <ng-container *ngIf="fb.tags?.includes('planogram-approved')">
            <span class="badge bg-success text-light">Planogram Approved</span>
          </ng-container>

          <button class="btn btn-sm btn-outline-light" (click)="replyToFeedback(fb.id)" title="Reply">
            <i class="bi bi-reply"></i>
          </button>
          <button
            class="btn btn-sm btn-outline-light"
            *ngIf="fb.userId === currentUserId"
            (click)="deleteFeedback(fb.id)"
            title="Delete">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>

      <div class="card-body">
        <p class="m-0">{{ fb.content }}</p>
      </div>

      <!-- Attachments -->
      <div *ngIf="fb.attachments?.length" ngbAccordion class="mt-2">
        <div ngbAccordionItem (shown)="onAttachmentsShown(fb)">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton>
              Attachments ({{ fb.attachments?.length }})
            </button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="mt-2 attachments">
                  <div class="d-flex flex-wrap gap-2">
                    <ng-container *ngFor="let att of fb.attachments">
                      <div class="attachment-item text-center p-2 border rounded small position-relative">
                        <button
                          type="button"
                          class="btn btn-sm btn-danger btn-remove-attachment position-absolute top-0 end-0 m-1 p-0"
                          (click)="deleteAttachment(att.attachmentId, fb)"
                          title="Delete attachment">
                          <i class="bi bi-x"></i>
                        </button>

                        <ng-container *ngIf="isImage(att.filename); else fileBlockTpl">
                          <img
                            [src]="thumbnailUrls.get(att.attachmentId)"
                            *ngIf="thumbnailUrls.get(att.attachmentId)"
                            alt="{{ att.filename }}"
                            class="img-thumbnail clickable"
                            style="width: 80px; height: 80px; object-fit: cover;"
                            (click)="openImage(att)"
                          />
                          <div class="text-truncate mt-1">{{ att.filename }}</div>
                        </ng-container>

                        <ng-template #fileBlockTpl>
                          <div class="clickable" (click)="downloadAttachment(att)">
                            <i class="bi bi-file-earmark fs-2 d-block"></i>
                            <div class="text-truncate">{{ att.filename }}</div>
                          </div>
                        </ng-template>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Recursive replies -->
    <ng-container *ngIf="fb.replies?.length">
      <ng-container
        *ngTemplateOutlet="feedbackTemplate; context: { list: fb.replies, level: level + 1 }"
      ></ng-container>
    </ng-container>
  </div>
</ng-template>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="addFeedback()">Add Feedback</button>
  <button type="button" class="btn btn-light" (click)="close()">Close</button>
</div>